import { render, staticRenderFns } from "./TrEdit.vue?vue&type=template&id=b2cf012e&"
import script from "./TrEdit.vue?vue&type=script&lang=js&"
export * from "./TrEdit.vue?vue&type=script&lang=js&"
import style0 from "./TrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports